import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { TegelModule } from '@scania/tegel-angular-17';

@Component({
  imports: [TranslatePipe, TranslateModule, TegelModule],
  selector: 'app-notification-popup',
  templateUrl: './notification-popup.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./notification-popup.component.scss'],
})
export class NotificationPopupComponent implements OnInit {
  @Input() message: any;
  @Output() closePopup: EventEmitter<any> = new EventEmitter();
  notificationUrl: string;
  constructor() {}

  ngOnInit() {
    if (this.message?.data?.service.toLowerCase().includes('departure scheduling')) {
      this.notificationUrl = self.location.origin + '/departure-scheduling';
    }
  }

  closeModal() {
    this.closePopup.emit();
  }
}
